export const isTokenExpired = (token) => {
    if (!token || !token.exp) {
      // If the token or expiration timestamp is missing, consider it expired.
      return true;
    }
  
    // current timestamp in seconds (UTC)
    const currentTimestamp = Math.floor(Date.now() / 1000);
  
    // Compare the current timestamp with the token's expiration timestamp
    return currentTimestamp > token.exp;
  };
  